import { Typography } from '@mui/material';
import { PiButton, PiLinkButton, PiPaper } from '@sensei/pi-component';
import React from 'react';
import useAddYourDeviceStyles from '../../../styles/opt-in/add-your-device.style';
import { OptInDeviceType } from '../../../types/opt-in-device.type';
import { useTranslation } from 'react-i18next';

type AddYourDeviceDialogProps = {
    device: OptInDeviceType;
    onDeviceClick: (id: OptInDeviceType) => void;
    onOptInLaterClick: () => void;
};

export function AddYourDeviceDialog(props: AddYourDeviceDialogProps) {
    const classes = useAddYourDeviceStyles();
    const { t } = useTranslation();

    return (
        <PiPaper className={classes.dialogPaper}>
            <div className={classes.dialogPaperContent}>
                <img
                    src={`/static/images/` + props.device.logoFileName}
                    className={classes.dialogPaperLogo}
                    alt={t('addYourDeviceDialog.whoop')}
                />
            </div>
            <PiButton
                fullWidth
                color="primary"
                className={classes.dialogButton}
                onClick={() => props.onDeviceClick(props.device)}
            >
                {t('addYourDeviceDialog.connect')}
            </PiButton>
            <Typography variant="body2" align="center">
                <PiLinkButton
                    onClick={() => props.onOptInLaterClick()}
                    className={classes.activateLater}
                >
                    {t('addYourDeviceDialog.connectLater')}
                </PiLinkButton>
            </Typography>
        </PiPaper>
    );
}
